import React from "react";

function Map() {
  return (
    <>
      <div className="bg-white">
        <div className="w-full h-[300px] p-5 !mb-10 relative">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d358026.4654658077!2d72.04721727343748!3d23.02133730000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e867d761c358f%3A0x9655b843577dd418!2sRohan's&#39;s%20Tax%20Services!5e1!3m2!1sen!2sin!4v1735539844425!5m2!1sen!2sin"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </>
  );
}

export default Map;
